<div class="flex items-center justify-between h-full w-full px-4 py-2 gap-4">
  <div class="flex flex-col justify-center items-end">
    <h3 class="text-md font-bold mb-[-5px] text-gray-700">{{ fullName() }}</h3>
    <span class="text-sm text-gray-500">{{ email() }}</span>
  </div>
  <div class="relative">
    <button
      type="button"
      [attr.aria-expanded]="menuOpen()"
      aria-haspopup="menu"
      aria-label="Menu compte"
      (click)="toggleMenu($event)"
      class="flex justify-center items-center w-10 h-10 bg-secondary/15
         text-secondary/70 font-bold rounded-full border border-gray-400
         cursor-pointer transition-colors hover:bg-secondary/25 hover:border-secondary/50"
    >
      {{ initial }}
    </button>

    @if (menuOpen()) {
      <div
        class="absolute right-0 top-full z-50 mt-2 min-w-[11rem] rounded-xl border border-gray-200 bg-white shadow-lg py-1"
        role="menu"
      >
        @if (settingsUrl()) {
          <a
            [routerLink]="settingsUrl()"
            (click)="closeMenu()"
            role="menuitem"
            class="flex w-full items-center gap-2 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
          >
            <span class="material-symbols-outlined text-[18px] leading-none text-gray-500">settings</span>
            Paramètres
          </a>
        }
        @if (isAdmin()) {
          <a
            routerLink="/dashboard/admin/users"
            (click)="closeMenu()"
            role="menuitem"
            class="flex w-full items-center gap-2 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
          >
            <span class="material-symbols-outlined text-[18px] leading-none text-gray-500">group</span>
            Utilisateurs
          </a>
        }
        <button
          type="button"
          role="menuitem"
          (click)="logout()"
          class="flex w-full items-center gap-2 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer border-0 bg-transparent text-left"
        >
          <span class="material-symbols-outlined text-[18px] leading-none text-gray-500">logout</span>
          Déconnexion
        </button>
      </div>
    }
  </div>

  @if (isAdmin()) {
    <div class="border bg-red-200 text-red-600 border-red-600 rounded-md py-1 px-2">
      ADMINISTRATEUR
    </div>
  }
</div>
